




















































































import { defineComponent, computed, ref, PropType, watch } from '@vue/composition-api';
import { AdgroupItem } from '../types';
import { CreationStep } from '@tt4b/ttam-enums';

const name = 'ttam-sidebar-level-node';
export default defineComponent({
  name,
  props: {
    curUid: {
      type: String,
      default: '',
    },
    adgroupNum: {
      type: Number,
      default: 1,
    },
    adgroupInfo: {
      type: Object as PropType<AdgroupItem>,
      default: () => ({}),
    },
    itemIndex: {
      type: Number,
      default: 1,
    },
  },
  setup(props, { emit }) {
    const isDraftStatus = computed(() => props.adgroupInfo.adgroupStatus === 'draft');
    const isPublishedStatus = computed(() => props.adgroupInfo.adgroupStatus === 'published');
    const isErrorStatus = computed(() => props.adgroupInfo.adgroupStatus === 'error');
    const isWarningStatus = computed(() => props.adgroupInfo.adgroupStatus === 'warning');
    const isFinishStatus = computed(() => props.adgroupInfo.adgroupStatus === 'finish');

    const isActive = computed(() => props.adgroupInfo.adgroupUuid === props.curUid);
    const isSubActive = computed(() => Boolean(props.adgroupInfo.ads?.find(item => item.adUid === props.curUid)));
    const closeArrowInitStatus = computed(() => isActive.value || isSubActive.value);

    const actionConfig = computed(() => props.adgroupInfo.actionConfig || []);

    const addIconPlacement = computed(() => (showAddIcon.value?.disabled ? 'right' : 'top'));
    /**
     * 处理 Select
     */
    function handleAdgroupSelect() {
      if (props.adgroupInfo.disabled || isFinishStatus.value || isActive.value) {
        return;
      }
      emit('select', props.adgroupInfo.level ?? 'adgroup', props.adgroupInfo.adgroupUuid);
    }

    function goToListPage(level: CreationStep, uuid: string) {
      emit('goToListPage', level, uuid);
    }

    return {
      name,
      isActive,
      isSubActive,
      closeArrowInitStatus,

      isDraftStatus,
      isPublishedStatus,
      isErrorStatus,
      isWarningStatus,
      isFinishStatus,

      addIconPlacement,
      actionConfig,

      handleAdgroupSelect,
      goToListPage,
      CreationStep,
    };
  },
});
